module.exports = __webpack_public_path__ + "f5b1fb6271b1b1d213ab0c9a65216192.png";